/* eslint-disable jsx-a11y/media-has-caption */
import { useRef, useEffect } from 'react';

type VideoPreviewProps = {
  stream: MediaStream;
  height?: number | string;
  width?: number | string;
  rounded?: boolean;
  mirrored?: boolean;
  className?: string;
  videoClassName?: string;
};

export function VideoPreview({
  stream,
  height = 100,
  width = 100,
  rounded = false,
  mirrored = true,
  className = '',
  videoClassName = '',
}: VideoPreviewProps) {
  const videoRef = useRef<HTMLVideoElement>(null);
  const resolvedHeight =
    typeof height === 'number' ? `${height}px` : height ?? '100px';
  const resolvedWidth =
    typeof width === 'number' ? `${width}px` : width ?? '100px';

  useEffect(() => {
    if (videoRef.current && stream) {
      videoRef.current.srcObject = stream;
    }
  }, [stream]);

  if (!stream) {
    return null;
  }

  return (
    <div
      className={`overflow-hidden bg-slate-950 ${
        rounded ? 'rounded-full' : 'rounded-2xl'
      } ${className}`}
      style={{
        height: resolvedHeight,
        width: resolvedWidth,
      }}
    >
      <video
        className={`h-full w-full object-cover ${
          mirrored ? '-scale-x-100' : ''
        } ${videoClassName}`}
        ref={videoRef}
        autoPlay
        playsInline
      />
    </div>
  );
}
